module.exports = "/images/vendor/flag-icon-css/flags/4x3/bv.svg?78bef9106e11eade7698e39f6ed831c7";